export default __webpack_public_path__ + "static/media/typicons.6697a4a6.svg";